import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import AnalysisSection from '../components/sections/AnalysisSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import ScreenshotsSection from '../components/sections/ScreenshotsSection';
import AboutSection from '../components/sections/AboutSection';
import FAQSection from '../components/sections/FAQSection';
import DownloadSection from '../components/sections/DownloadSection';

const HomePage: React.FC = () => {
    return (
        <div className="min-h-screen">
            <HeroSection />
            <AnalysisSection />
            <HowItWorksSection />
            <FeaturesSection />
            <ScreenshotsSection />
            <AboutSection />
            <FAQSection />
            <DownloadSection />
        </div>
    );
};

export default HomePage;
